import type { FaireProductEntity } from "../../entity_types/product";

export const p_3cgv9mu7fc: FaireProductEntity = {
  token: "p_3cgv9mu7fc",
  type: "product",
  name: "Plum Purple Knotted Newborn Baby Gown",
  brandToken: "b_3pci2bfmjr",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b73a79376dddefe514939c94526b1dc0ef7f5462a8996215a727567a325b182d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/85644f7e3995838c4f9fb30bf20e92b37ecaddee3641268dc33e4d876462c17d.jpeg",
    "https://cdn.faire.com/fastly/67708426f7243de5c48e82be8e1e24143dca1d7fb554045d7144547808662248.jpeg",
  ],
  priceDollars: 14.5,
  description:
    "\nWelcoming a newborn into the world is a magical yet challenging journey, and as an expecting mother, you're likely exploring ways to make those first few months as comfortable as possible for your little one. One item that can offer both practicality and comfort is a knotted baby gown. These gowns are thoughtfully designed with your newborn’s needs in mind, featuring an open bottom that can be easily tied or untied. This simple yet ingenious feature allows for quick and fuss-free diaper changes, making those late-night moments a little easier on you both. The gown’s gentle, breathable fabric ensures your baby stays cozy and warm without overheating, providing them with a snug and secure feeling reminiscent of the womb.",
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:19.039Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
